export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.25 4A.75.75 0 014 3.25h16a.75.75 0 01.75.75v2.586c0 .464-.184.909-.513 1.237l-5.487 5.488V18a.75.75 0 01-.415.67l-4 2A.75.75 0 019.25 20v-6.69L3.763 7.824a1.75 1.75 0 01-.513-1.237V4zm1.5.75v1.836c0 .066.026.13.073.177l5.707 5.707c.141.14.22.331.22.53v5.787l2.5-1.25V13a.75.75 0 01.22-.53l5.707-5.707a.25.25 0 00.073-.177V4.75H4.75z\" fill=\"#6F7488\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.47 6.47a.75.75 0 011.06 0l3 3a.75.75 0 11-1.06 1.06l-3-3a.75.75 0 010-1.06z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};